import { useMutation, useQueryClient } from "@tanstack/react-query";
import { auth } from "../../../components/Auth/Auth.jsx";

// Updates the hidden status of a shop in the backend.
const updateShopHiddenStatus = async ({ shopId, isHidden }) => {
  if (!shopId || typeof isHidden !== "boolean") {
    throw new Error("Shop ID and hidden status are required!");
  }

  const user = auth.currentUser;

  if (!user) {
    throw new Error("No authenticated user found");
  }

  const token = await user.getIdToken();

  const response = await fetch(
    // Updates whether a shop is hidden or visible.
    `${import.meta.env.VITE_API_URL}/api/v2/shop/hidden`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        shopId,
        isHidden,
      }),
    },
  );

  if (!response.ok) {
    const errorData = await response.json();

    throw new Error(errorData.message || "Failed to update shop hidden status");
  }

  return response.json();
};

// Provides the mutation used to hide or restore a shop.
export const useShopHiddenStatusData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateShopHiddenStatus,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["AllShops"],
      });
    },

    onError: (error) => {
      console.error("Failed to update shop hidden status:", error);
    },
  });
};
